import { render, staticRenderFns } from "./ChildrensStudy.vue?vue&type=template&id=67d52055&"
import script from "./ChildrensStudy.vue?vue&type=script&lang=js&"
export * from "./ChildrensStudy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports